import { render, staticRenderFns } from "./WhatWillYouLearn.vue?vue&type=template&id=7e03e032&scoped=true"
import script from "./WhatWillYouLearn.vue?vue&type=script&lang=js"
export * from "./WhatWillYouLearn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e03e032",
  null
  
)

export default component.exports